import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ca4a200"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-start" }, "Filtrar Médicos", -1))
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "no-data-message" }
const _hoisted_4 = { class: "flex flex-col md:flex-row md:justify-end gap-2" }
const _hoisted_5 = { class: "w-full md:max-w-[180px] order-2 md:order-1 mr-auto" }
const _hoisted_6 = { class: "w-full md:max-w-[140px] order-2 md:order-1" }
const _hoisted_7 = { class: "w-full md:max-w-[140px] order-1 md:order-2" }

import { ref, computed, onMounted } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import { useToast } from 'vue-toastification'
import StatesFromBR from '@/config/StatesFromBR'
import { storeToRefs } from 'pinia'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { useErrorToast } from '@/composables/useErrorToast'
import DoctorService from '@/Network/Services/DoctorService'
import { debounce } from 'lodash'
import { mdiFilterOff } from '@mdi/js'

type SelectedItemType = { id: string; name: string; display: string }
export type StoredValuesFiltersType = {
  selectedItems: SelectedItemType[]
  selectedCrmUFs: string[]
  selectedCompanies: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterModal',
  props: {
    modalStateProp: { type: Boolean },
    storedValuesFilters: {}
  },
  emits: ['close', 'apply-filters', 'clear-filters'],
  setup(__props: any, { emit }) {

const props = __props;



const { listCompanies } = storeToRefs(useCompanyStore())

const loading = ref(false)
const toast = useToast()
const { notifyError } = useErrorToast()

const selectedItems = ref<SelectedItemType[]>([])
const selectedCrmUFs = ref<string[]>([])
const selectedCompanies = ref<string[]>([])



const searchTermFilter = ref('')
const suggestions = ref<{ id: string; display: string }[]>([])

onMounted(() => {
  if (props.storedValuesFilters) {
    selectedItems.value = props.storedValuesFilters.selectedItems
    selectedCrmUFs.value = props.storedValuesFilters.selectedCrmUFs
    selectedCompanies.value = props.storedValuesFilters.selectedCompanies
  }
})

const isFilterValid = computed(() => {
  return (
    selectedItems.value.length > 0 ||
    selectedCrmUFs.value.length > 0 ||
    selectedCompanies.value.length > 0
  )
})

const doctorService = new DoctorService()

const noDataMessage = computed(() => {
  if (!searchTermFilter.value) {
    return 'Digite um nome ou CRM para buscar.'
  }
  return `Nenhum resultado encontrado para "${searchTermFilter.value}".`
})

const fetchSuggestions = debounce(async (term: string) => {
  searchTermFilter.value = term

  if (!term) {
    suggestions.value = []
    return
  }

  try {
    const results = await doctorService.searchDoctors(term)

    suggestions.value = results.map((doctor) => ({
      id: doctor.id,
      name: doctor.user.name,
      display: `${doctor.user.name} (CRM: ${doctor.mainCrm.number}/${doctor.mainCrm.uf})`
    }))
  } catch (error) {
    console.error('Erro ao buscar sugestões:', error)
    notifyError(error, 'Não foi possível buscar sugestões de médicos. Tente novamente.')
    suggestions.value = []
  }
}, 300)

const applyFilters = async () => {
  if (!isFilterValid.value) {
    toast.error('Por favor, selecione pelo menos um filtro para aplicar.')
    return
  }

  try {
    loading.value = true

    const names = selectedItems.value
      .filter((item) => !isCrm(item.display))
      .map((item) => item.name)

    const crms = selectedItems.value
      .filter((item) => isCrm(item.display))
      .map((item) => item.display.split('/')[0])

    // Emitindo os filtros aplicados
    emit('apply-filters', {
      names,
      crms,
      crmUFs: selectedCrmUFs.value,
      companies: selectedCompanies.value,
      storeValuesFilters: {
        selectedItems: selectedItems.value,
        selectedCrmUFs: selectedCrmUFs.value,
        selectedCompanies: selectedCompanies.value
      }
    })

    close()
  } catch (error) {
    console.error(error)
    toast.error('Erro ao aplicar filtros. Tente novamente.')
  } finally {
    loading.value = false
  }
}

const clearFilters = () => {
  selectedItems.value = []
  selectedCrmUFs.value = []
  selectedCompanies.value = []
  searchTermFilter.value = ''
  suggestions.value = []
  emit('clear-filters')
}

const isCrm = (term: string) => {
  const crmPattern = /^\d{1,6}(\/[A-Za-z]{2})?$/
  return crmPattern.test(term)
}

const close = () => {
  selectedItems.value = []
  selectedCrmUFs.value = []
  selectedCompanies.value = []
  emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: close,
    modalActive: _ctx.modalStateProp
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(OutlineButton, {
            onClick: _cache[3] || (_cache[3] = () => clearFilters()),
            text: "Limpar filtros",
            "prepend-icon": _unref(mdiFilterOff)
          }, null, 8, ["prepend-icon"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(GhostButton, {
            onClick: close,
            text: "Cancelar",
            width: "100%"
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(FilledButton, {
            disabled: !isFilterValid.value,
            loading: loading.value,
            onClick: applyFilters,
            text: "Aplicar Filtros",
            width: "100%"
          }, null, 8, ["disabled", "loading"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_autocomplete, {
          ref: "searchAutocomplete",
          modelValue: selectedItems.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event)),
          label: "Buscar por Nome ou CRM",
          multiple: "",
          chips: "",
          clearable: "",
          "deletable-chips": "",
          variant: "outlined",
          class: "w-full",
          items: suggestions.value,
          "item-title": "display",
          "item-value": "id",
          "return-object": "",
          "onUpdate:search": _unref(fetchSuggestions),
          "no-filter": ""
        }, {
          "no-data": _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(noDataMessage.value), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "items", "onUpdate:search"]),
        _createVNode(_component_v_autocomplete, {
          ref: "crmUFAutocomplete",
          modelValue: selectedCrmUFs.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCrmUFs).value = $event)),
          items: _unref(StatesFromBR),
          label: "Selecione os CRMUFs",
          multiple: "",
          chips: "",
          clearable: "",
          "deletable-chips": "",
          variant: "outlined",
          class: "w-full"
        }, null, 8, ["modelValue", "items"]),
        _createVNode(_component_v_autocomplete, {
          ref: "companyAutocomplete",
          modelValue: selectedCompanies.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedCompanies).value = $event)),
          items: _unref(listCompanies),
          label: "Selecione as Empresas",
          multiple: "",
          chips: "",
          clearable: "",
          "deletable-chips": "",
          variant: "outlined",
          class: "w-full"
        }, null, 8, ["modelValue", "items"])
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})